import { applyFilters, doRequest, doGenericRequest } from "./helpers";

export default class EmailAttachmentsService {
  /**
   * Get email attachments for table display with filtering and pagination
   * @param {Object} filters - Optional filters for the query
   * @returns {Promise<Object>} Paginated email attachments data
   */
  static async getEmailAttachments(filters = null) {
    let path = `/email/assets/attachments/`;
    path = applyFilters(filters, path);
    return doRequest("GET", path);
  }

  /**
   * Get email attachments for dropdowns/filters
   * @returns {Promise<Array>} List of email attachments for filters
   */
  static async getEmailAttachmentsForFilters() {
    return doRequest("GET", "/email/assets/attachments/for_filters");
  }

  /**
   * Get a single email attachment by ID
   * @param {number} id - Email attachment ID
   * @returns {Promise<Object>} Email attachment data
   */
  static async getEmailAttachment(id) {
    return doRequest("GET", `/email/assets/attachments/${id}`);
  }

  /**
   * Create a new email attachment
   * @param {Object} data - Attachment data including name, file_name, s3_url
   * @returns {Promise<Object>} Created email attachment
   */
  static async createEmailAttachment(data) {
    return doRequest("POST", "/email/assets/attachments/", {
      data,
    });
  }

  /**
   * Update an existing email attachment
   * @param {number} id - Email attachment ID
   * @param {Object} data - Updated attachment data
   * @returns {Promise<Object>} Updated email attachment
   */
  static async updateEmailAttachment(id, data) {
    return doRequest("PUT", `/email/assets/attachments/${id}`, {
      data,
    });
  }

  /**
   * Delete an email attachment
   * @param {number} id - Email attachment ID
   * @returns {Promise<Object>} Deletion response
   */
  static async deleteEmailAttachment(id) {
    return doRequest("DELETE", `/email/assets/attachments/${id}`);
  }
}
